import { writeClipboard } from "../../../../lib/utils";
export function copyDataPath(ctx, ev) {
  const text = ctx.dataPath;
  writeClipboard(text);
  ctx.uc.$message.success(`已经复制：${text}`);
  ev.stopPropagation();
  ev.preventDefault();
}
export function invalidGetter(id) {
  console.error(`[UICore] 不能取变量 ${id} 的值，因为它没有配置 Getter 或者 Getter 存在语法错误`);
}
export function invalidSetter(id) {
  throw new Error(`[UICore] 不能赋值到变量 ${id}，因为它没有配置 Setter 或者 Setter 存在语法错误`);
}